export function monitoringIsInGrace(now: number, sessionStartedAt: number, switchGraceUntil: number, startupGraceMs: number): boolean {
  return now - sessionStartedAt < startupGraceMs || now < switchGraceUntil;
}
